// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.device_kind_enum */
var DeviceKindEnum;
(function (DeviceKindEnum) {
    DeviceKindEnum["BREWLINK"] = "BREWLINK";
})(DeviceKindEnum || (DeviceKindEnum = {}));
;
export default DeviceKindEnum;
/** Zod schema for device_kind_enum */
export const deviceKindEnum = z.nativeEnum(DeviceKindEnum);
//# sourceMappingURL=DeviceKindEnum.js.map